import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Coins, Eye, EyeOff, Ticket, Trophy, UsersRound } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const logoUrl = `${process.env.PUBLIC_URL}/logo.png`;
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setError("");
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.email || !form.password) {
      setError("Email and password are required.");
      return;
    }
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-shell">
      <div className="auth-split">
        {/* Left panel */}
        <div className="auth-panel-left">
          <div className="auth-panel-brand">
            <span className="auth-logo">
              <img src={logoUrl} alt="Lucky Pool logo" className="auth-logo-image" />
            </span>
            {/* <strong>Lucky Pool</strong> */}
          </div>
          <div className="auth-panel-body">
            <h2>Win big together.</h2>
            <p>Join thousands of players pooling entries for every Powerball draw. One ticket, shared glory.</p>
            <div className="auth-features">
              <div className="auth-feature"><Ticket size={18} /><span>Verified ticket uploads</span></div>
              <div className="auth-feature"><Trophy size={18} /><span>Transparent winner payouts</span></div>
              <div className="auth-feature"><UsersRound size={18} /><span>Up to 300 members per pool</span></div>
            </div>
          </div>
          <div className="auth-panel-footer">
            <span>app.luckypool.com</span>
          </div>
        </div>

        {/* Right panel */}
        <div className="auth-panel-right">
          <div className="auth-card">
            <div className="auth-card-header">
              <h1>Sign in</h1>
              <p className="auth-sub">Welcome back — your pool is waiting.</p>
            </div>

            {error && <div className="auth-error" role="alert">{error}</div>}

            <form onSubmit={handleSubmit} noValidate>
              <div className="auth-field">
                <label htmlFor="email">Email address</label>
                <input
                  id="email" name="email" type="email"
                  autoComplete="email" required
                  value={form.email} onChange={handleChange}
                  placeholder="you@example.com"
                />
              </div>
              <div className="auth-field">
                <label htmlFor="password">
                  Password
                  <Link to="/forgot-password" className="auth-forgot">Forgot password?</Link>
                </label>
                <div className="auth-input-wrap">
                  <input
                    id="password" name="password"
                    type={showPass ? "text" : "password"}
                    autoComplete="current-password" required
                    value={form.password} onChange={handleChange}
                    placeholder="••••••••"
                  />
                  <button type="button" className="auth-eye" onClick={() => setShowPass(!showPass)} aria-label="Toggle password">
                    {showPass ? <EyeOff size={17} /> : <Eye size={17} />}
                  </button>
                </div>
              </div>
              <button type="submit" className="auth-submit" disabled={loading}>
                {loading ? <span className="auth-spinner" /> : "Sign In"}
              </button>
            </form>

            <p className="auth-switch">
              Don't have an account? <Link to="/signup">Create one free</Link>
            </p>
            <p className="auth-admin-link">
              Admin? <Link to="/admin/login">Sign in to Command Center</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
